import logoSrc from '../../assets/logo-ellezeta.png';

interface LogoProps {
  width?: number;
}

export default function Logo({ width = 180 }: LogoProps) {
  return (
    <img
      src={logoSrc}
      alt="Ellezeta Building"
      style={{ display: 'block', width: `${width}px`, height: 'auto' }}
    />
  );
}
